var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBnbLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "292px",
    height: "291px",
    viewBox: "0 0 292 291",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-40.0%",
    width: "214.3%",
    height: "206.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-40.0%",
    width: "214.3%",
    height: "206.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-40.0%",
    width: "214.3%",
    height: "206.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-40.0%",
    width: "214.3%",
    height: "206.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-40.0%",
    width: "214.3%",
    height: "206.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-40.0%",
    width: "214.3%",
    height: "206.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-40.0%",
    width: "214.3%",
    height: "206.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-40.0%",
    width: "214.3%",
    height: "206.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-40.0%",
    width: "214.3%",
    height: "206.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#FAE000",
    x: 0,
    y: 0,
    width: 291,
    height: 291,
    rx: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,190.677792 C292,245.906267 247.228475,290.677792 192,290.677792 L101,290.677792 C45.771525,290.677792 1,245.906267 1,190.677792 C29.8627658,176.103166 52.4312344,166.820613 68.7054058,162.830135 C84.7645677,158.892377 110.696099,156.282576 146.5,155.00073 C175.774158,154.949826 201.158461,157.559627 222.65291,162.830135 C233.491795,165.487863 256.607491,174.770416 292,190.677792 Z",
    id: "Rectangle-3-Copy",
    fill: "#E4CD00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(74.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-2",
    fill: "#6A6A6A",
    cx: 74.5,
    cy: 142.5,
    r: 67.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3397446,0 L23.3397446,0 C35.8546581,-2.29895231e-15 46,10.1453419 46,22.6602554 L46,135.259038 C46,147.26624 36.2662397,157 24.2590379,157 L24.2590379,157 C12.2108732,157 2.4045738,147.307867 2.26349051,135.260529 L0.944839463,22.6587017 C0.799996725,10.2903371 10.709119,0.146378321 23.0774836,0.00153558279 C23.1649002,0.000511869705 23.252322,1.60592662e-17 23.3397446,0 Z",
    id: "Rectangle-Copy",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#37B7C4",
    cx: 68.5,
    cy: 150.5,
    r: 67.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#37B7C4",
    x: 1,
    y: 8,
    width: 37,
    height: 157,
    rx: 18.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-2",
    fill: "#6A6A6A",
    cx: 70,
    cy: 149,
    r: 34
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(21.000000, 121.000000)",
    fill: "#E4CD00"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-Copy",
    transform: "translate(31.500000, 58.000000) rotate(31.000000) translate(-31.500000, -58.000000) ",
    points: "30.3308483 98 44 18 19 25.1615038"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    cx: 45.5,
    cy: 31.5,
    r: 31.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    filter: "url(#filter-1)",
    transform: "translate(91.000000, 52.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14.5 L9.57571308,4.6125177",
    id: "Line-3-Copy-10",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 11,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    filter: "url(#filter-2)",
    transform: "translate(91.000000, 91.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14.5 L9.57571308,4.6125177",
    id: "Line-3-Copy-10",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 11,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    filter: "url(#filter-3)",
    transform: "translate(91.000000, 134.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14.5 L9.57571308,4.6125177",
    id: "Line-3-Copy-10",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 11,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-4",
    filter: "url(#filter-4)",
    transform: "translate(133.000000, 120.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14.5 L9.57571308,4.6125177",
    id: "Line-3-Copy-10",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 11,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-5",
    filter: "url(#filter-5)",
    transform: "translate(170.000000, 134.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14.5 L9.57571308,4.6125177",
    id: "Line-3-Copy-10",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 11,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-6",
    filter: "url(#filter-6)",
    transform: "translate(184.000000, 161.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14.5 L9.57571308,4.6125177",
    id: "Line-3-Copy-10",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 11,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-7",
    filter: "url(#filter-7)",
    transform: "translate(184.000000, 198.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14.5 L9.57571308,4.6125177",
    id: "Line-3-Copy-10",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 11,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-8",
    filter: "url(#filter-8)",
    transform: "translate(152.000000, 220.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14.5 L9.57571308,4.6125177",
    id: "Line-3-Copy-10",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 11,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-3",
    filter: "url(#filter-9)",
    transform: "translate(91.000000, 176.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14.5 L9.57571308,4.6125177",
    id: "Line-3-Copy-10",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 11,
    cy: 3,
    r: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbLogo);
export default __webpack_public_path__ + "static/media/bnb-logo.2f93ec5e317e08ef064faa6fc3a74a5f.svg";
export { ForwardRef as ReactComponent };